import { createGlobalStyle } from 'styled-components'
import { OptionsHOC } from '../../hocs'

const GlobalStyleInject = ({ getOption }) => {
  const GlobalStyle = createGlobalStyle`
    :root {
      --main-color: ${getOption('styles.accentColor', '#62bb46')};
      --link-color: ${getOption('styles.linkColor', '#62bb46')};
    }
  `
  return <GlobalStyle />
}

export default OptionsHOC(GlobalStyleInject)
